// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MathUtils } from '@shared/utils/MathUtils';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iOBV = 'iOBV';
export class IOBV extends iBuildInIndicator {
    constructor(priceType) {
        super(1);
        this.FPriceType = priceType;
    }
    get Name() {
        return iOBV;
    }
    get Key() {
        return this.DefaultKey + this.FPriceType;
    }
    OnQuote(ci, callBound, callFromRefresh) {
        const Parent = this.Parent;
        if (!Parent) {
            return;
        }
        const FCount = this.FCount;
        const FPriceType = this.FPriceType;
        if (FCount === 1) {
            this.SetValue(Parent.GetVolume(0), undefined, undefined); // this.SetValue(Utils.MAXVALUE)
            return;
        }
        const curPrice = this.GetPrice(FPriceType, 0);
        const prevPrice = this.GetPrice(FPriceType, 1);
        const prevVolume = FCount === 2 ? MathUtils.ProcessNaN(Parent.GetVolume(0)) : this._GetValue(0, 1);
        if ((FPriceType === PriceType.Typical && Math.abs(prevPrice - curPrice) < 0.00001) || prevPrice === curPrice) {
            this.SetValue(prevVolume, undefined, undefined);
            return;
        }
        const volume = MathUtils.ProcessNaN(Parent.GetVolume(FCount - 1));
        if (curPrice > prevPrice) {
            this.SetValue(prevVolume + volume, undefined, undefined);
        }
        else /* if (curPrice < prevPrice) */ {
            this.SetValue(prevVolume - volume, undefined, undefined);
        }
    }
}
